<template>
  <v-autocomplete
    :loading="loading"
    v-model="model"
    :search-input.sync="search"
    :items="items"
    :item-value="stationOrOffice + '.code'"
    :item-text="stationOrOffice + '.name'"
    return-object
    :hint="hint"
    persistent-hint
    flat
    hide-no-data
    no-filter
    :label="label"
    :rules="rules"
    @input="changed"
    @dblclick.native="search = '?'"
    :disabled="disabled || station.disabled"
    ref="suggester_office"
  ></v-autocomplete>
</template>

<script>
import { debounce } from "lodash";
import { suggest } from "../resources";
import { postProcessMessageDOM } from "./util.js";

export default {
  name: 'v-suggest-office',
  props: {
    "label": {
      type: String
    },
    "value": {
      type: Object
    },
    "rules": {
      type: Array
    },
    "station": {
      type: Object,
      default: () => { return {}  }
    },
    "disabled": {
      type: Boolean
    },
    "isCourierShipment": {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      search: "",
      model: "",
      address: " ",
      stationOrOffice: "office",
    }
  },

  computed: {
    hint() {
      let hint = this.address;
      const modelObj = this.model[this.stationOrOffice];
      if (this.model && modelObj && modelObj.schedule) {
        const isCourier = this.isCourierShipment;

        setTimeout(() => {
          postProcessMessageDOM(this, {
            servicing:     { courier: modelObj.schedule.small,      cargo: modelObj.schedule.large },
            isCourier
          }, "suggester_office");
        }, 200);
      }
      return hint;
    }
  },

  watch: {
    search(val) {
      // console.log("officeSuggest.search:watch("+val+")");
      this.suggest(val);
    },
    value(val) {
      if (val.station)
        console.log("officeSuggest.value:watch(val.code = "+ val.station.code + ", val.text=" + val.station.name + ")");
      else
        console.log("officeSuggest:value(null station)");
      this.init();
    },
    station(val) {// => station.source|target = { disabled, value: { code, name, distance } }
      console.log("officeSuggest.station:watch(val.disabled = ${val}, val.value = ", val.value);
      if (val && val.value) {
        this.model = { station : { code : val.value.code, name : val.value.name } };
        if (val.value.distance)
          this.address = val.value.distance + (this.value && this.value.address && this.value.address.settlement && this.value.address.settlement.name ? " " + this.$t("from") + " " + this.value.address.settlement.name : "");
        this.items = new Array();
        this.items.push(this.model);
        this.changed();
      }
    },
  },

  methods: {
    suggestImpl(val) {
      // console.log("officeSuggest.suggestImpl(" + val + ")");
      val && val !== this.model.text && this.querySelections(val);
    },

    querySelections(q) {
      if (this.loading)
        return;

      let settlement = null;
      // console.log("officeSuggest.querySelection(" + q + ")");
      this.loading = true;
      if (q === "?")
        q = "";
      suggest.suggestOffice({q, settlement}).then((response) => {
        this.items = response.body.result.map(elem => {
          elem.station.schedule = (elem.address && elem.address.settlement && elem.address.settlement.schedule) || null;
          return {
            [this.stationOrOffice]: elem.station,
            address: elem.address,
            geo: elem.geo,
          };
        });
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.loading = false;
      });
    },

    init() {// this.value = shipment.source|target
      // console.log("officeSuggest.init");
      // console.log(this.value);
      if (!!this.value) {
        let code = (!!this.value[this.stationOrOffice] && this.value[this.stationOrOffice].code) || "";
        let name = (!!this.value[this.stationOrOffice] && this.value[this.stationOrOffice].name) || "";
        const settlement = !!this.value[this.stationOrOffice] && !!this.value[this.stationOrOffice].address && this.value[this.stationOrOffice].address.settlement;
        const schedule              = settlement ? settlement.schedule              : null;
        const delivery_days_courier = settlement ? settlement.delivery_days_courier : null;
        const delivery_days_cargo   = settlement ? settlement.delivery_days_cargo   : null;
        this.search = name;
        this.model = {
          address: this.value[this.stationOrOffice] && this.value[this.stationOrOffice].address,
          [this.stationOrOffice] : { code, name, schedule, delivery_days_courier, delivery_days_cargo }
        };
        this.items = new Array();
        this.items.push(this.model);
      } else {
        console.log("WARN: office suggest null model");
      }
    },

    changed() {
      if (this.model && this.model.address)
        this.address = this.model.address.simple;

      let//
      s = {};
      s = Object.assign( s, this.value );
      if (this.model) {
        s[this.stationOrOffice] = {
          code : this.model[this.stationOrOffice].code,
          name : this.model[this.stationOrOffice].name,
          address : { country: this.model.address && this.model.address.country, settlement : {
            schedule : this.model[this.stationOrOffice].schedule,
            delivery_days_courier : this.model[this.stationOrOffice].delivery_days_courier,
            delivery_days_cargo : this.model[this.stationOrOffice].delivery_days_cargo
          } }
        }
      } else {
        s[this.stationOrOffice] = {
          code : null,
          name : ""
        }
      }
      this.$emit("input", s);
    },
  },

  created() {
    // console.log('officeSuggest.created');
    this.suggest = debounce(this.suggestImpl, 500);
  },

  mounted() {
    // console.log('officeSuggest.mounted');
    this.stationOrOffice = !!this.station && !!this.station.value ? "station" : "office";
    this.init();
  }
}
</script>

<style scoped>
.v-select >>> .v-messages__message {
  font-size: 11px;
}
.v-select >>> .v-messages__message > div {
  display: inline;
  margin-right: 1em;
}
.v-select >>> .v-messages__message > div:last-child {
  margin-right: 0;
}
</style>
